export default __webpack_public_path__ + "static/media/fallback.014088e2.svg";